import { styled } from 'styled-components';

export const Container = styled.div`
  height: 85px;
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.colors.white};

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;

export const Title = styled.h1`
  font-size: 1.875rem;
  font-weight: 800;
  margin: 0;
`;

export const ButtonClose = styled.button`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  border-radius: 55px;
  font-size: 0.875rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.dark.color};
  background: ${({ theme }) => theme.colors.light.color};
  box-shadow: 0 2px 0 0 rgba(103, 120, 115, 0.2);
  padding: 0.625rem 1rem;

  svg {
    width: 12px;
    color: ${({ theme }) => theme.colors.dark.color};
  }
`;
